export const INITIAL_STATE = {
    resume: null,
}